/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { Step } from '../discovery-questions-lib/steps'

import type { NonEmptyArray } from '../ts-utils'

export const ONBOARDING_COMBINE_STEPS: NonEmptyArray<Step> = [
  Step.FullName,
  Step.ExperienceLevel,
  Step.TrialIntent,
  Step.UseCase,
  Step.CspRegion,
]

export const ONBOARDING_COMBINE_STEPS_WITH_SEARCH_TYPE: NonEmptyArray<Step> = [
  ...ONBOARDING_COMBINE_STEPS,
  Step.SearchProjectSubtype,
]

export const ONBOARDING_USER_COMBINE_STEPS: NonEmptyArray<Step> = [
  Step.FullName,
  Step.ExperienceLevel,
  Step.TrialIntent,
  Step.UseCase,
  Step.PickResource,
  Step.CspRegion,
]

export const ONBOARDING_USER_COMBINE_STEPS_WITH_SEARCH_TYPE: NonEmptyArray<Step> = [
  ...ONBOARDING_USER_COMBINE_STEPS,
  Step.SearchProjectSubtype,
]
